import { createFileRoute } from "@tanstack/react-router";
import { SurveyPermissionsPage } from "./-components/SurveyPermissionsPage";
import { setProfileSubPageBodyColors } from "./-utils/profileHost";

export const Route = createFileRoute("/profile/survey-permissions")({
    component: SurveyPermissionsRoute,
    beforeLoad: () => {
        setProfileSubPageBodyColors(
            "var(--color-background-profile-secondary)",
            "var(--color-background-profile-secondary)",
        );
    },
    head: ({ match }) => ({
        meta: [
            {
                title: `Survey permissions - ${match.search.tenant} ${match.search.locale}`,
            },
        ],
    }),
});

function SurveyPermissionsRoute() {
    const { tenant } = Route.useSearch();

    return <SurveyPermissionsPage tenant={tenant} />;
}
